import { AllPaths } from "../types";
import { tokenState } from "../../auth/tokenState";
import { AxiosInstance } from "axios";

export function interceptInsertAuthToken(client: AxiosInstance): number {
  return client.interceptors.request.use(async (config) => {
    const url = config.url as AllPaths;
    if (url !== "/auth/login/" && url !== "/v1/login/") {
      const accessToken = await tokenState.getAccessToken();
      if (accessToken !== null) {
        config.headers!.Authorization = `Bearer ${accessToken}`;
      } else {
        config.headers = {} as any;
      }
    }
    return config;
  });
}

export function interceptAutoRefreshAuthToken(client: AxiosInstance): number {
  return client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const url = error.config.url as AllPaths;
      
      // Check for "Invalid token" in error response
      const errorDetail = error.response?.data?.detail;
      const isInvalidToken = errorDetail === "Invalid token." || errorDetail === "Invalid token";
      
      //@ts-ignore
      if (url !== "/auth/login/" && url !== "/v1/login/" && (error.response?.status === 401 || isInvalidToken)) {
        // Clear tokens if we have an invalid token error
        if (isInvalidToken) {
          tokenState.clearTokens();
          // Redirect to login
          window.location.href = "/login";
          return Promise.reject(error);
        }
        
        // For 401 errors, try refreshing token
        tokenState.invalidateAccessToken();
        const accessToken = await tokenState.getAccessToken();
        if (accessToken !== null) {
          // got new access token, retry request
          return await client.request(error.config);
        }
      }
      throw error;
    }
  );
}
